/* eslint-disable react/no-danger */
import React from 'react';
import { Link } from 'gatsby';
import Slider from 'react-slick';
import moment from 'moment';
import 'moment/locale/fr';
import 'moment/locale/it';
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
} from 'react-share';
import { LinkedinFollowCompany } from '../../../utils/react-social-plugin';
import fb from '../../../../static/img/icn-share-fb.svg';
import twitter from '../../../../static/img/icn-share-tw.svg';
import linkedin from '../../../../static/img/icn-share-url.svg';

function Item({ props, setTag }) {
  let mediaUrl;
  let logoUrl;
  if (props) {
    mediaUrl = props.node.featured_media ? props.node.featured_media.source_url : null;
    logoUrl = props.node.acf.logo ? props.node.acf.logo.source_url : null;
  }
  const lang = props && props.node.polylang_current_lang;

  return (
    <div className="slide-post">
      <Link to={`/${lang}/blog/${props.node.slug}`} className="slide-post-img">
        {mediaUrl && <img src={mediaUrl} data-src={mediaUrl} alt={props.node.title} className="post-img" />}
        {!mediaUrl && logoUrl && <img src={logoUrl} data-src={logoUrl} alt={props.node.title} className="post-img" />}
      </Link>
      <div className="d-flex align-items-center tag-holder">
        <div>
          {props.node.categories.slice(0, 1).map((item) => (<div className="category-tag" onClick={setTag} data-tag={item.name} data-lang={props.node.polylang_current_lang} key>{item.name}</div>))}
        </div>
      </div>
      <Link to={`/${lang}/blog/${props.node.slug}`} className="slide-post-link"><div dangerouslySetInnerHTML={{ __html: props.node.title }} /></Link>
      <div className="slide-post-text">{props.node.content}</div>
      <div className="slide-post-date">
        {lang === 'fr' ? 'Le ' : null}
        {lang === 'it' ? 'Il ' : null}
        {moment(props.node.date).locale(lang).format('DD MMMM YYYY')}
      </div>
    </div>
  );
}

export default function Post({ post, posts, setTag }) {
  let mediaUrl, logoUrl;
  if (post) {
    mediaUrl = post.featured_media ? post.featured_media.source_url : null;
    logoUrl = post.acf.logo ? post.acf.logo.source_url : null;
  }

  const settings = {
    className: 'post-slider',
    slidesToShow: 3,
    adaptiveHeight: false,
    infinite: true,
    responsive: [
      {
        breakpoint: 768,
        settings: 'unslick'
      }
    ]
  };

  // Shuffle for related posts
  if (posts) {
    const shufflePosts = (array) => {
      let currentIndex = array.length, temporaryValue, randomIndex;
      while (currentIndex !== 0) {
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;
        temporaryValue = array[currentIndex];
        array[currentIndex] = array[randomIndex];
        array[randomIndex] = temporaryValue;
      }
      return array.slice(0, 3);
    };

    shufflePosts(posts.edges);
  }

  let relatedPostTitle;
  if (post) {
    if (post.polylang_current_lang === 'fr') {
      relatedPostTitle = 'Articles recommandés';
    } else if (post.polylang_current_lang === 'it') {
      relatedPostTitle = 'Articoli consigliati';
    }
  }

  return (
    <section className="section-post">
      {post &&
        <div className="content-holder">
          <div className="container post">
            {mediaUrl && <img src={mediaUrl} data-src={mediaUrl} alt={post.title} className="post-img" />}
            {!mediaUrl && logoUrl && <div className="box-item"><img src={logoUrl} data-src={logoUrl} alt={post.title} className="post-img" /></div>}
            <h1 className="post-title" dangerouslySetInnerHTML={{ __html: post.title }} />
            <div className="post-date">
              {post.polylang_current_lang === 'fr' ? 'Le ' : null}
              {post.polylang_current_lang === 'it' ? 'Il ' : null}
              {moment(post.date).locale(post.polylang_current_lang).format('DD MMMM YYYY')}
            </div>
            <div className="wrapper-post-share">
              <div className="post-share">
                <FacebookShareButton url={window.location.href}><img src={fb} alt={'facebook'} className="fab fb-icon" /></FacebookShareButton>
                <TwitterShareButton url={window.location.href}><img src={twitter} alt={'twitter'} className="fab fb-icon" /></TwitterShareButton>
                <LinkedinShareButton url={window.location.href}><img src={linkedin} alt={'linkedin'} className="fab fb-icon" /></LinkedinShareButton>
                {typeof window !== 'undefined' && <LinkedinFollowCompany
                  companyId={28656800}
                  counter="top" // Or "right"
                  lang="fr_FR"
                />}
              </div>
            </div>
            <div dangerouslySetInnerHTML={{ __html: post.content }} className="post-text" />
            {post.acf.cta_button_text &&
              <div className="cta-btn">
                <a
                  href={post.acf.cta_button_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="izi-btn izi-btn-large izi-btn-green"
                >
                  {post.acf.cta_button_text}
                </a>
              </div>}
          </div>

          <div className="wrapper-related-posts">
            <div className="container">
              <h4 className="post-subsection-title">
                {relatedPostTitle}
              </h4>

              {posts.edges.length ?
                <Slider {...settings} arrows={false}>
                  {posts.edges
                    .slice(0, 3)
                    .filter((item) => item.node.title !== post.title)
                    .map((item) => <Item props={item} key setTag={setTag} />)}
                </Slider> : ''}
            </div>
          </div>
        </div>}
    </section>
  );
}
